// Copyright 2026 Hardfin, Inc.
import { FilterOption } from '@/components/filter-toggle-group';
import {
  CheckCircleOutlined,
  ListRounded,
  LocalShippingOutlined,
  PendingOutlined,
} from '@/constants/hardfin-standard-icons';
import { MovementStatus } from '@/movement/api/types';

export const MOVEMENT_STATUS_OPTIONS: FilterOption<MovementStatus>[] = [
  { value: 'all', label: 'All', icon: <ListRounded fontSize="small" /> },
  {
    value: 'open',
    label: 'Open',
    icon: <PendingOutlined fontSize="small" />,
  },
  {
    value: 'in_transit',
    label: 'In transit',
    icon: <LocalShippingOutlined fontSize="small" />,
  },
  {
    value: 'delivered',
    label: 'Delivered',
    icon: <CheckCircleOutlined fontSize="small" />,
  },
];
